(function(){
  'use strict';

  function getConfig(){
    return window.WWSeasonalEvent || {};
  }

  function buildPromoNav(){
    var cfg=getConfig();

    var desktop=document.querySelector('.ww-nav');
    if(desktop&&!desktop.querySelector('[data-ww-promotions-link]')){
      var a=document.createElement('a');
      a.href='/pages/promotions';
      a.className='ww-promotions-nav';
      a.textContent='Promotions';
      a.setAttribute('data-ww-promotions-link','desktop');
      desktop.appendChild(a);
    }

    var mobile=document.querySelector('.ww-mobile-menu__nav');
    if(mobile&&!mobile.querySelector('[data-ww-promotions-link]')){
      var m=document.createElement('a');
      m.href='/pages/promotions';
      m.className='ww-mobile-menu__direct ww-promotions-mobile';
      m.setAttribute('data-ww-promotions-link','mobile');
      m.innerHTML='<span>'+(cfg.eyebrow||'Promotions')+'</span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 18 6-6-6-6"></path></svg>';
      mobile.insertBefore(m,mobile.firstChild);
    }

    var event=document.querySelector('.ww-header-event');
    if(event){
      var eventLink=event.querySelector('a');
      if(eventLink){
        eventLink.href='/pages/promotions';
        eventLink.textContent='Shop Promotions';
        eventLink.setAttribute('data-ww-promotions-event-link','true');
      }
      event.classList.add('is-campaign-ready');
    }
  }

  function applyPromoCopy(){
    var cfg=getConfig();
    var page=document.querySelector('.ww-promotions-page');
    if(!page)return;

    var kicker=page.querySelector('.ww-promotions-kicker');
    if(kicker && cfg.eyebrow)kicker.textContent=cfg.eyebrow;

    var h1=page.querySelector('.ww-promotions-hero h1');
    if(h1 && cfg.heading)h1.textContent=cfg.heading;

    var intro=page.querySelector('.ww-promotions-hero__copy > p');
    if(intro && cfg.copy)intro.textContent=cfg.copy;

    var box=page.querySelector('[data-ww-promo-countdown]');
    if(box){
      if(cfg.deadlineIso)box.setAttribute('data-deadline',cfg.deadlineIso);
      var label=box.querySelector('span');
      var small=box.querySelector('small');
      if(label && cfg.deadlineLabel)label.textContent=cfg.deadlineLabel;
      if(small && cfg.deadlineLabel)small.textContent=cfg.deadlineLabel;
    }
  }

  function startCountdown(){
    var box=document.querySelector('[data-ww-promo-countdown]');
    if(!box)return;
    var out=box.querySelector('[data-ww-promo-countdown-value]');
    if(!out)return;

    function tick(){
      var deadline=box.getAttribute('data-deadline');
      if(!deadline)return;
      var diff=new Date(deadline).getTime()-Date.now();
      if(diff<=0){
        out.textContent='Promotion ended';
        box.classList.add('is-ended');
        return;
      }
      var d=Math.floor(diff/864e5),
          h=Math.floor((diff%864e5)/36e5),
          m=Math.floor((diff%36e5)/6e4),
          s=Math.floor((diff%6e4)/1e3);
      out.textContent=(d>0?d+'d ':'')+String(h).padStart(2,'0')+'h '+String(m).padStart(2,'0')+'m '+String(s).padStart(2,'0')+'s';
      window.setTimeout(tick,1000);
    }

    tick();
  }

  function init(){
    buildPromoNav();
    applyPromoCopy();
    startCountdown();
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',function(){
    buildPromoNav();
    applyPromoCopy();
  });
})();